module.exports = "/images/vendor/flag-icon-css/flags/1x1/gb-eng.svg?eabfeadc28e73c627eb8c65999d93aae";